
namespace RioERP.Orders {
    export class OrderBookColumns {
        static columnsKey = 'Orders.OrderBook';
    }
}